import { ConstructionComponentInfo } from "@interfaces/constructor/constructor";
import CumulativeDonateBonus from "./cumulativeDonateBonus";
import DonateBonuses from "./donateBonuses";
import DonateBonusList from "./donateBonusList";
import DonateBonusName from "./donateBonusName";
import DonateBonusThreshold from "./donateBonusThreshold";
import DonateBonusValue from "./donateBonusValue";

const DonateBonusesInfo: ConstructionComponentInfo = {
    component: DonateBonuses,
    props: [
        'donate_bonuses_per_page'
    ],
    addedChildProps: [
        'donate_bonuses_count',
        'pagination_current_page',
        'pagination_total_pages',
        'pagination_per_page',
        'pagination_set_page',
        'pagination_next_page',
        'pagination_prev_page'
    ]
}

const DonateBonusListInfo: ConstructionComponentInfo = {
    component: DonateBonusList,
    props: [
        'bonus_type',
        'bonus_threshold_type',
        'pagination_per_page'
    ],
    addedChildProps: [
        'donate_bonus_index',
        'donate_bonus_active'
    ],
    injectChild: [
        'pagination_current_page',
        'pagination_per_page'
    ]
}

const CumulativeDonateBonusInfo: ConstructionComponentInfo = {
    component: CumulativeDonateBonus,
    addedChildProps: [
        'cumulative_bonus_level'
    ]
}

const DonateBonusNameInfo: ConstructionComponentInfo = {
    component: DonateBonusName,
    requiredParent: [
        'DonateBonusList'
    ]
}

const DonateBonusThresholdInfo: ConstructionComponentInfo = {
    component: DonateBonusThreshold,
    requiredParent: [
        'DonateBonusList'
    ]
}

const DonateBonusValueInfo: ConstructionComponentInfo = {
    component: DonateBonusValue,
    requiredParent: [
        'DonateBonusList'
    ]
}

export {
    DonateBonusListInfo,
    CumulativeDonateBonusInfo,
    DonateBonusNameInfo,
    DonateBonusThresholdInfo,
    DonateBonusValueInfo,
    DonateBonusesInfo
}